import { useLazyQuery, useQuery } from "@apollo/client";
import { JOB_TITLES } from "../job-title.queries";
import { JobTitlesQuery, JobTitlesQueryVariables } from "../../../__generated__/JobTitlesQuery";

export const useJobTitles = (variables: JobTitlesQueryVariables) => {
  return useQuery<JobTitlesQuery, JobTitlesQueryVariables>(JOB_TITLES, { variables });
};

export const useLazyJobTitles = () => {
  return useLazyQuery<JobTitlesQuery, JobTitlesQueryVariables>(JOB_TITLES);
};
